/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import platform from '@/shared/utils/platform';
import { Component, Vue } from 'vue-property-decorator';
import { APPLY_PRODUCT, RECEIVE_QUOTA, REPAYMENT } from './constants';

const style = require('./index.module.scss');

@Component
export default class UsingGuid extends Vue {
  private activeIndex = 0;

  private tabItems = [{
    name: '申请额度',
    value: 'finance_receiveQuota',
    index: 0,
  }, {
    name: '如何提现',
    value: 'finance_applyProduct',
    index: 1,
  }, {
    name: '如何还款',
    value: 'finance_repayment',
    index: 2,
  }];

  private created() {
    const index = Number(this.$route.query.index || 0);
    const rightIndex = this.tabItems.find((item) => item.index === index);
    this.activeIndex = rightIndex ? index : 0;
    this.$ubtPageButton(this.tabItems[this.activeIndex].value);
  }

  // 绘制每个 tab 页主题文案
  private renderTitle(title: string) {
    return (
      <div class={style.tabTitle}>
        {title}
      </div>
    );
  }

  // 绘制详细介绍文案标题
  private renderText(text: string, hasIcon = true) {
    return (
      <div class={[style.tabText, hasIcon && style.tabTextWithIcon]}>
        {text}
      </div>
    );
  }

  // 绘制详细介绍文案
  private renderInfo(info: string) {
    return (
      <div class={style.tabInfo}>
        {info}
      </div>
    );
  }

  private onChangeTab(index: number) {
    if (this.activeIndex !== index) {
      this.activeIndex = index;
      this.$ubtPageButton(this.tabItems[index].value);
    }
  }

  private mounted() {
    setTimeout(() => {
      /** 修复IOS 16问题：因前置页面首页已滚动到底部，此时打开使用指南页，页面已滚动的距离可能未重置 */
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
    });
  }

  // 绘制申请额度页
  private renderReceiveQuota() {
    return (
      <div class={style.receiveQuota}>
        <div class={style.noticeBar}>个⼈身份信息只⽤于授信申请，我们将严格保护您的隐私</div>
        <div class={style.receiveQuotaTitle}>
          {this.renderTitle('仅需3步 快速拿额度')}
        </div>

        <div class={style.receiveQuotaFirst}>
          <div class={style.receiveQuotaFirstTitle}>
            {this.renderText('首页点击“申请额度”后，填写个人资料')}
          </div>
          <div class={style.receiveQuotaFirstImg} />
          <div class={style.receiveQuotaFirstInfo}>
            {this.renderInfo('请正确填写个人信息，它将作为您获得额度的重要依据哦~')}
          </div>
        </div>
        <span class={[style.arrow, style.receiveQuotaArrow]} />

        <div class={style.receiveQuotaSecond}>
          <span class={style.receiveQuotaSecondImg} />
          <div class={style.receiveQuotaSecondContent}>
            <div class={style.receiveQuotaSecondText}>
              {this.renderText('身份认证')}
            </div>
            <div class={style.receiveQuotaSecondInfo}>
              {this.renderInfo('将本人身份证完整放到识别框内进行拍摄，避免曝光、照片较模糊等情况')}
            </div>
          </div>
        </div>
        <span class={[style.arrow, style.receiveQuotaArrow]} />

        <div class={style.receiveQuotaThird}>
          <div class={style.receiveQuotaThirdImg} />
          <div class={style.receiveQuotaThirdContent}>
            <div class={style.receiveQuotaThirdText}>
              {this.renderText('人脸识别')}
            </div>
            <div class={style.receiveQuotaThirdInfo}>
              {this.renderInfo('正对手机，保证光线充足，按照指引操作；完成验证后，同意协议并提交')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 绘制如何提现页
  private renderApplyProduct() {
    return (
      <div class={style.applyProduct}>
        <div class={style.applyProductTitle}>
          {this.renderTitle('便捷提现 最快3分钟到账')}
        </div>

        <div class={style.applyProductFirst}>
          <div class={style.applyProductFirstImg} />
          <div class={style.applyProductFirstContent}>
            {this.renderText('成功申请额度后点击“去提现”')}
          </div>
        </div>
        <div class={[style.arrow, style.applyProductArrow]} />

        <div class={style.applyProductSecond}>
          <div class={[
            style.applyProductSecondImg,
            (platform.isAlipayMini || platform.isDingTalk) && style.applyProductSecondImgAli,
          ]} />
          <div class={style.applyProductSecondContent}>
            <div
              class={[style.applyProductSecondContenttexts, style.applyProductSecondContent01]}
            >
              <div class={style.applyProductSecondContenttextLeft}>01.</div>
              <div class={style.applyProductSecondContenttextRight}>
                <div class={style.applyProductSecondContenttextRightText}>
                  {this.renderText('选择放款机构后输入借款金额', false)}
                </div>
                <div
                  class={[
                    style.applyProductSecondContenttextRightInfo,
                    style.applyProductSecondContenttextRightInfo1,
                  ]}
                >
                  {this.renderInfo('根据您的借款需求输入金额')}
                </div>
              </div>
            </div>
            <div
              class={[style.applyProductSecondContenttexts, style.applyProductSecondContent02]}
            >
              <div class={style.applyProductSecondContenttextLeft}>02.</div>
              <div class={style.applyProductSecondContenttextRight}>
                {this.renderText('选择还款期限', false)}
                <div
                  class={[
                    style.applyProductSecondContenttextRightInfo,
                    style.applyProductSecondContenttextRightInfo2,
                  ]}
                >
                  {this.renderInfo('期限越长，还款压力越小')}
                </div>
              </div>
            </div>
            <div
              class={[style.applyProductSecondContenttexts, style.applyProductSecondContent02]}
            >
              <div class={style.applyProductSecondContenttextLeft}>03.</div>
              <div class={style.applyProductSecondContenttextRight}>
                {this.renderText(platform.isAlipayMini ? '支付宝账号绑定' : '添加银行卡', false)}
                <div
                  class={[
                    style.applyProductSecondContenttextRightInfo,
                    style.applyProductSecondContenttextRightInfo3,
                  ]}
                >
                  {this.renderInfo(platform.isAlipayMini
                    ? '签约免密支付，绑定支付宝账号用于放款和还款'
                    : '注意查看放款机构所支持的银行卡列表，了解限额情况')}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class={[style.arrow, style.applyProductArrow]} />

        <div class={style.applyProductThird}>
          <div class={style.applyProductThirdImg} />
          <div class={style.applyProductThirdContent}>
            <div class={style.applyProductThirdtext}>
              {this.renderText('确认提现')}
            </div>
            <div class={style.applyProductThirdInfo}>
              {this.renderInfo('提交“提现申请”后，同意相关合同，即可提现')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 绘制如何还款页
  private renderRepayment() {
    return (
      <div class={style.repayment}>
        <div class={style.repaymentTitle}>
          {this.renderTitle('按时还款 为您的信用加分')}
        </div>

        <div class={style.repaymentFirst}>
          <div class={style.repaymentFirstImg} />
          {this.renderText('自动还款')}
          <div class={style.repaymentFirstInfo}>
            {this.renderInfo('借款时将开通代扣服务，请您注意协议内容，并在还款日前保证卡内余额充足')}
          </div>
        </div>

        <div class={style.repaymentSecond}>
          <div class={style.repaymentSecondImg} />
          <div class={style.repaymentSecondContent}>
            {this.renderText('手动还款')}
            <div class={style.repaymentSecondInfo}>
              {this.renderInfo('成功借款后，在还款当日去首页点击“去还款”')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  private render() {
    return (
      <div class={style.usingGuid}>
        <div class={style.tabbar}>
          {this.tabItems.map((item) => (
            <div
              class={item.index === this.activeIndex && style.activeTab}
              onClick={this.onChangeTab.bind(this, item.index)}
            >
              { item.name }
            </div>
          ))}
        </div>

        {this.activeIndex === RECEIVE_QUOTA && this.renderReceiveQuota()}

        {this.activeIndex === APPLY_PRODUCT && this.renderApplyProduct()}

        {this.activeIndex === REPAYMENT && this.renderRepayment()}
        <div class={style.footer} />
      </div>
    );
  }
}
